(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatchCustomerDialogController', PatchCustomerDialogController);

    PatchCustomerDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PatchCustomer', 'SocialInsurance', 'Country', 'Region', 'Prefecture', 'City'];

    function PatchCustomerDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PatchCustomer, SocialInsurance, Country, Region, Prefecture, City) {
        var vm = this;
        vm.patchCustomer = entity;
        vm.socialinsurances = SocialInsurance.query();
        vm.countries = Country.query();
        vm.regions = Region.query();
        vm.prefectures = Prefecture.query();
        vm.cities = City.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:patchCustomerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.patchCustomer.id !== null) {
                PatchCustomer.update(vm.patchCustomer, onSaveSuccess, onSaveError);
            } else {
                PatchCustomer.save(vm.patchCustomer, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateOfBirth = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
